import GLightbox from "glightbox";

export default () => {
    const element = document.querySelector(".js-glightbox");

    if (element === null) {
        return false;
    }

    GLightbox({
        selector: ".js-glightbox",
        touchNavigation: false,
        videosWidth: 1130,
    });
};
